import { put, select, takeLatest } from 'redux-saga/effects';
import { Field, Task, TaskAPI } from 'api/tasks';
import { StoreActionProps } from 'data/core';
import {
  selectTaskStatusField,
  selectTaskStatusFieldDefaultValue,
} from 'data/fields/selectors';
import {
  getProjectDependencyMapKey,
  getProjectTasksQueryKey,
} from 'queries/common';
import { logger } from 'services';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import {
  CreateSubTaskActionPayload,
  createSubTaskSagaAction,
} from '../actions';
import { addSubTaskToTask, createSubTaskSuccess } from '../slice';

function* createSubTaskSaga(
  action: StoreActionProps<CreateSubTaskActionPayload>,
): Generator {
  const { payload } = action;

  const { projectId, taskId, queryClient, updateLocalState, ...rest } = payload;
  const { fieldId } = (yield select(selectTaskStatusField)) as Field;
  const fieldValue = (yield select(
    selectTaskStatusFieldDefaultValue,
  )) as number;

  try {
    yield put(
      addSubTaskToTask({
        projectId,
        taskId,
        parentTask: rest.parentTask,
        taskName: rest.taskName,
        fields: [{ fieldId, fieldValue }],
      }),
    );
    const task = (yield TaskAPI.createTask(projectId, rest)) as Task;

    // This is done to optimistically update the local state for sub tasks list.
    if (updateLocalState) {
      updateLocalState(task);
    }

    yield put(
      createSubTaskSuccess({
        projectId,
        parentTask: rest.parentTask,
        taskId,
        task,
      }),
    );
    yield invalidateTaskQuery(taskId);
    yield invalidateTaskQuery(rest.parentTask);
    yield queryClient.refetchQueries(
      getProjectTasksQueryKey(['project_id', projectId]),
    );
    yield queryClient.refetchQueries(getProjectDependencyMapKey(projectId));
  } catch (error) {
    logger.error('createSubTaskSaga failed', { error });
  }
}

export function* watchCreateSubTaskSaga(): Generator {
  yield takeLatest(createSubTaskSagaAction.type, createSubTaskSaga);
}
